import { Check, Link2 } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { copyText } from '@/lib/clipboard'
import { publicQuotesUrl } from '@/models/publicQuotes'
import { QuotesEvent, QuotesSurface, trackQuotesEvent } from './quotesAnalytics'

/**
 * Copies the read-only share link for this application's quotes. Anyone holding it can
 * read the quotes without signing in, so the button says what it hands over.
 */
export function CopyQuotesLinkButton({ applicationId }: { applicationId: string }) {
  const [copied, setCopied] = useState(false)
  const url = publicQuotesUrl(applicationId)

  async function copy() {
    try {
      await copyText(url)
      setCopied(true)
      // Rendered in the nav, above the quotes page's own scope — hence the spelled-out context.
      trackQuotesEvent(QuotesEvent.LINK_COPIED, {
        surface: QuotesSurface.APP,
        application_id: applicationId,
      })
      setTimeout(() => setCopied(false), 2000)
      toast.success('Link copied! Anyone with the link can view your quotes')
    } catch {
      toast.error("We couldn't copy the link. Try again.")
    }
  }

  return (
    <Button type="button" variant="link" size="sm" className="gap-1.5" onClick={copy}>
      {copied ? <Check className="size-4" /> : <Link2 className="size-4" />}
      Share
    </Button>
  )
}
